// src/services/listeNoire.js — LA LISTE NOIRE, depuis n'importe quel écran :
// lire, y mettre quelqu'un (une fiche, un profil d'une campagne, un fil de
// conversation), l'en retirer. Le serveur est la seule vérité (la fiche
// porte la marque, la barrière est chez lui) ; ici on parle au serveur une
// fois, et chaque écran affiche son message tel quel.
import APIService from './api';

const BASE = 'https://besoins-tat-production.up.railway.app';
const authH = () => ({ Authorization: `Bearer ${APIService.getToken()}` });
const jsonH = () => ({ ...authH(), 'Content-Type': 'application/json' });

// « Pas encore côté serveur » = la ROUTE manque (404 sans notre JSON, ou 501).
const absente = (r, j) => r.status === 501 || (r.status === 404 && j.success !== false);
const ABSENTE = 'La liste noire arrive côté serveur.';

export async function listerListeNoire({ q = '', origine = '' } = {}) {
  try {
    const p = new URLSearchParams({ ...(q ? { q } : {}), ...(origine ? { origine } : {}) });
    const r = await fetch(`${BASE}/liste-noire${p.toString() ? `?${p}` : ''}`, { headers: authH() });
    const j = await r.json().catch(() => ({}));
    if (absente(r, j)) return { ok: false, absente: true, error: ABSENTE };
    if (!r.ok || j.success === false) return { ok: false, error: j.error || `Impossible (${r.status})` };
    return { ok: true, entrees: Array.isArray(j.entrees) ? j.entrees : [], compteurs: j.compteurs || {}, origines: Array.isArray(j.origines) ? j.origines : [] };
  } catch (e) { return { ok: false, error: e.message }; }
}

/** { candidate_id } | { profil: { recruiterId, name, firstName, publicUrl, link, email, phone } } | { conversation_id } — et TOUJOURS un motif. */
export async function ajouterListeNoire(payload) {
  try {
    const r = await fetch(`${BASE}/liste-noire`, { method: 'POST', headers: jsonH(), body: JSON.stringify(payload) });
    const j = await r.json().catch(() => ({}));
    if (absente(r, j)) return { ok: false, absente: true, error: ABSENTE };
    if (!r.ok || j.success === false) return { ok: false, error: j.error || `Impossible (${r.status})`, champ: j.champ };
    return { ok: true, data: j.data, message: j.data?.message || 'Sur la liste noire.' };
  } catch (e) { return { ok: false, error: e.message }; }
}

export async function leverListeNoire(candidateId, motif = null) {
  try {
    const r = await fetch(`${BASE}/liste-noire/${candidateId}`, { method: 'DELETE', headers: jsonH(), body: JSON.stringify({ motif: motif || null }) });
    const j = await r.json().catch(() => ({}));
    if (absente(r, j)) return { ok: false, absente: true, error: ABSENTE };
    if (!r.ok || j.success === false) return { ok: false, error: j.error || `Impossible (${r.status})` };
    return { ok: true, data: j.data, message: j.data?.message || 'Retiré de la liste noire.' };
  } catch (e) { return { ok: false, error: e.message }; }
}

export async function historiqueListeNoire(candidateId) {
  try {
    const r = await fetch(`${BASE}/liste-noire/${candidateId}/historique`, { headers: authH() });
    const j = await r.json().catch(() => ({}));
    if (!r.ok || j.success === false) return { ok: false, error: j.error || `Impossible (${r.status})` };
    return { ok: true, data: Array.isArray(j.data) ? j.data : [] };
  } catch (e) { return { ok: false, error: e.message }; }
}
